import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import SynopsisSection from './components/SynopsisSection';
import CastingSection from './components/CastingSection';
import FundingGoalSection from './components/FundingGoalSection';
import RewardsSection from './components/RewardsSection';
import TestimonialSection from './components/TestimonialSection';
import ReviewSection from './components/ReviewSection';
import LocationSection from './components/LocationSection';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);
  const [showDonationModal, setShowDonationModal] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleDonationClick = () => {
    setShowDonationModal(true);
  };

  const copyAccountNumber = () => {
    navigator.clipboard.writeText('3333075828912');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  useEffect(() => {
    const buttons = document.querySelectorAll('button');
    buttons.forEach(button => {
      if (button.textContent?.includes('지금 후원하기')) {
        button.onclick = handleDonationClick;
      }
    });
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      <HeroSection onDonateClick={handleDonationClick} />
      <AboutSection />
      <SynopsisSection />
      <CastingSection />
      <FundingGoalSection onDonateClick={handleDonationClick} />
      <RewardsSection />
      <TestimonialSection />
      <ReviewSection />
      <LocationSection />
      <Footer />

      {showDonationModal && (
        <div className="fixed inset-0 bg-black/60 z-[100] flex items-center justify-center px-4" onClick={() => setShowDonationModal(false)}>
          <div className="bg-white rounded-3xl p-8 max-w-md w-full shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="text-center mb-6">
              <div className="w-16 h-16 flex items-center justify-center bg-amber-100 rounded-full mx-auto mb-4">
                <i className="ri-bank-card-line text-3xl text-amber-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2" style={{ fontFamily: "'Noto Serif KR', serif" }}>
                후원 계좌 안내
              </h3>
              <p className="text-sm text-gray-600">
                아래 계좌로 후원금을 보내주세요
              </p>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-2xl p-6 mb-6">
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-600">은행</span>
                  <span className="text-base font-bold text-gray-900">카카오뱅크</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-600">예금주</span>
                  <span className="text-base font-bold text-gray-900">마스터 액터스</span>
                </div>
                <div className="border-t border-amber-200 pt-3 mt-3">
                  <div className="flex items-center justify-between gap-3">
                    <div className="flex-1">
                      <span className="text-xs text-gray-500 block mb-1">계좌번호</span>
                      <span className="text-xl font-black text-gray-900 tracking-wider">3333-0758-2891-2</span>
                    </div>
                    <button
                      onClick={copyAccountNumber}
                      className="px-4 py-2 bg-amber-600 text-white rounded-lg text-sm font-semibold hover:bg-amber-700 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
                    >
                      {copied ? (
                        <>
                          <i className="ri-check-line"></i>
                          복사됨
                        </>
                      ) : (
                        <>
                          <i className="ri-file-copy-line"></i>
                          복사
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-xl p-4 mb-6">
              <div className="flex items-start gap-3">
                <i className="ri-information-line text-amber-600 text-lg mt-0.5"></i>
                <div className="text-xs text-gray-600 leading-relaxed">
                  <p className="mb-2">• 입금 시 입금자명에 <strong>연락처</strong>를 함께 기재해 주세요</p>
                  <p className="mb-2">• 리워드 발송을 위해 후원 후 이메일로 연락처를 보내주세요</p>
                  <p>• 문의: kmiw6@naver.com</p>
                </div>
              </div>
            </div>

            <button
              onClick={() => setShowDonationModal(false)}
              className="w-full py-3 bg-gray-900 text-white rounded-full font-semibold hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              닫기
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
